import { jsx as _jsx } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useAppliedFiltersCount } from "~/hooks/filters/useAppliedFiltersCount";
import { useApplyFilters } from "~/hooks/filters/useApplyFilters";
import { useSearchParams } from "~/hooks/search/useSearchParams";
import { clearAllFiltersAction } from "~/store/filters/actions";
export const PublicSearchActions = /*#__PURE__*/ memo((param)=>{
    let { onClearSearchValue } = param;
    const { search } = useSearchParams();
    const { filtersCount } = useAppliedFiltersCount();
    const { clearSearchAndFilters } = useApplyFilters();
    const dispatch = useDispatch();
    const onClick = useCallback(()=>{
        clearSearchAndFilters();
        dispatch(clearAllFiltersAction());
        onClearSearchValue();
    }, [
        onClearSearchValue,
        clearSearchAndFilters,
        dispatch
    ]);
    if (!filtersCount && !search) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Button, {
        appearance: "outline",
        color: "grey",
        "data-testid": "CLEAR_FILTER_BUTTON",
        onClick: onClick,
        prefix: /*#__PURE__*/ _jsx(Close, {
            className: "size-3"
        }),
        size: "small",
        children: filtersCount > 0 ? "Clear all" : "Clear"
    });
});
PublicSearchActions.displayName = "PublicSearchActions";
